module.exports = __webpack_public_path__ + "img/logo.b5dcef61.png";